import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class BookingType {
  constructor (params = {}) {
    const {
      id,
      sequence,
      externalIds,
      attributes,
      name
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.attributes = attributes || null
    this.name = name || null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      attributes: item.attributes,
      name: item.name
    }
  }
}
